import store from "../../../store";

export default function useBase64() {
    const multiple = store.getters['fileUploader/getMultiple']

    function loadBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })
    }

    async function getBase64(files) {
        const filePathsPromises = []

        if (files) {
            Array.from(files).forEach(file => {
                if (file.type.includes('image/')) {
                    filePathsPromises.push(loadBase64(file))
                }
            })

            const filePaths = await Promise.all(filePathsPromises)

            return multiple ? filePaths : filePaths[0]
        }

        return null
    }

    return {
        getBase64
    }
}
